import {
    AfterViewChecked,
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Optional
} from '@angular/core';

import {
    getPrettyPropertyRecordCalculationStatus,
    getCalculationStatusActualityById
} from '../../../../../shared/enums';

import IZoningCodeCalculationStatistic = ZoningAPI.IZoningCodeCalculationStatistic;
import * as _ from 'lodash';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-zcv-calc-process-details-view',
    templateUrl: './zcv-calc-process-details-view.component.html',
    styleUrls: ['./zcv-calc-process-details-view.component.scss']
})
export class ZCVCalcProcessDetailsViewComponent implements OnInit, OnDestroy, AfterViewChecked {
    getCalculationStatusActualityById;
    getPrettyPropertyRecordCalculationStatus;

    isOpenChart = false;
    isOpenPRThreadsLits = false;

    @Input()
    task: IZoningCodeCalculationStatistic;

    @Input()
    hidePRThreadsList?: boolean;

    private destroy$ = new Subject<boolean>();

    constructor(
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public data: IZoningCodeCalculationStatistic,
        private cdRef: ChangeDetectorRef
    ) {
        this.getCalculationStatusActualityById = getCalculationStatusActualityById;
        this.getPrettyPropertyRecordCalculationStatus = getPrettyPropertyRecordCalculationStatus;
    }

    // TODO :: we should have one source of data.
    ngOnInit() {
        this.task = _.get(this, 'data.zcVersionStatistic') || this.data || this.task;
    }

    ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    summaryStatistic({ statsByStatus }) {
        return statsByStatus.reduce(
            function(accumulator, statistic) {
                return {
                    count: accumulator.count + statistic.count,
                    ratio: Number((accumulator.ratio + statistic.ratio).toFixed(2))
                };
            },
            { count: 0, ratio: 0 }
        );
    }

    statusFormatter(calculationStatusCode: number) {
        return getPrettyPropertyRecordCalculationStatus(calculationStatusCode);
    }
}
